import withLayout from '../../hocs/Layout'
import { Box } from '@mui/material'
import PageTitle from '../../common/PageTitle'
import { pageContainerSx } from '../../styles/patterns'
import NPRCall from './NPRCalls'

// Standalone route for the NPR Call Recordings table (wired to NPR_RECORDING_SEARCH).
// Kept a dedicated page (not a tab) so the KPI summary cards have room to render, matching NDR.
const CallRecordings = () => (
  <Box sx={pageContainerSx}>
    <PageTitle subTitle='Review NPR call recordings, outcomes and responses'>Call Recordings</PageTitle>
    <NPRCall />
  </Box>
)

export default withLayout(CallRecordings)
